<template>
    <el-drawer v-model="optionparam.view" size="22%" direction="rtl" :before-close="handleClose">
        <el-empty description="暂无数据" v-if="memberlist.length==0" />
        <div class="ttl-goods-list" @scroll="handleScroll($event)" v-loading="LoadingObj" v-if="memberlist.length > 0">
            <div class="ttl-goods-infos" v-for="(item,index) in memberlist" :key="index">
                <el-image :src="item.thumb" fit="cover" />
                <div class="ttl-member-info left20">
                    <div class="ttl-attention">
                        <span class="ttl-goods-name">{{item.name}}</span>
                        <span class="ttl-goods-phone">{{item.phone}}</span>
                    </div>
                    <div class="ttl-attention">
                        <span class="ttl-goods-iscompany">{{item.iscompany}}</span>
                    </div>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';

export default {
    props:['view','option'],
    components:{

    },
    data() {
        return {
            LoadingObj:false,  //loading对象   
            optionparam: {
                view:false,
                type:'',
                memberid:'',
                p:0,
                rollpage:5,
            },
            isloading:false,
            isfinish:false,
            memberlist:[],
        }
    },
    
    watch: {
        view(val) {
            if(val) {
                this.isfinish=false;
                this.optionparam.view=true;
                this.optionparam.p=0;
                for(var i in this.option) this.optionparam[i]=this.option[i];
                this.memberlist=[];
                this.GetList();
            }
        }
    },

    methods: {

        //关闭窗口
        handleClose() {
            this.optionparam.view=false;
            this.$emit('finish',{type:'close'});
        },

        //查看关注商品信息
        GetList() {
            if(this.isfinish) return true; //数据已经滚动完成
            if(this.isloading) return false;
            this.isloading=true;

            this.optionparam.p++;
            var param={memberid:this.optionparam.memberid,p:this.optionparam.p,rollpage:this.optionparam.rollpage};
            var method='';
            if(this.optionparam.type=='attention') {method='GET_MEMBER_ATTENTION'}

            this.LoadingObj=true;
            INTERFACE_MODEL_MEMBER[method](param).then((res) => {
                 this.LoadingObj=false;
                 if(res.status > 0) return false;
                 if(res.data.list.length==0) this.isfinish=true;
                 for(var i=0;i < res.data.list.length;i++) this.memberlist.push(res.data.list[i]);
                 this.isloading=false;
            });
        },  


        //滚动触发操作
        handleScroll(event) {
            const{ scrollTop, scrollHeight, clientHeight }=event.target;
            //检查是否滚动到底部
            const isBottom = scrollHeight - (scrollTop + clientHeight) < 100; // 这里的1是一个阈值，可以根据需要调整
            if(isBottom) {
                this.GetList();
            }
        },

    },
}
</script>
<style scoped>
.ttl-goods-list {display: inline-block;width:100%;height:100%;overflow-y:auto;}
.ttl-goods-infos {display: inline-flex;align-items: center;width:100%;font-size:0;padding:25px 0;border-bottom:1px solid #F0F2F5;}
.ttl-goods-infos .el-image {display: inline-block;width:50px;height:50px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info {display:inline-block;width:calc(100% - 50px - 20px);}
.ttl-attention {display: inline-flex;align-items: center;width:100%;font-size:13px;position:relative;}
.ttl-goods-name {font-size:13px;}
.ttl-goods-phone {font-size:13px;position:absolute;right:0;color:#333333;}
.ttl-goods-iscompany {font-size:12px;color:#999999;margin-top:5px;}
::-webkit-scrollbar {width:0;}
</style>